module.exports = __webpack_public_path__ + "img/recommendation-5.587b7c40.svg";